var youtube = "//s3.amazonaws.com/edge-assets.lemonade.com/youtube-2e6dec23b425462cd8e6efe5c297fe9f.svg";

export { youtube as default };
